import { Button } from 'flowbite-react';
import { useCallback, useState } from 'react';
import { HiX } from 'react-icons/hi';
import { Separator } from '../separator';
import { Textarea } from '../textarea';

interface ITextAreaModalProps {
  title: string;
  areaLabel: string;
  approveButtonText?: string;
  onClose: () => void;
  onApprove: (value: string) => void;
}
export const TextAreaModal = (props: ITextAreaModalProps) => {
  const [value, setValue] = useState<string>('');

  const handleApprove = useCallback(() => {
    props.onApprove(value);
  }, [value]);

  return (
    <div>
      <div className="flex pb-5">
        <h3 className="text-lg font-semibold text-gray-900">{props.title}</h3>
        <button
          onClick={props.onClose}
          className="text-gray-400 hover:text-gray-600 ml-auto"
        >
          <HiX className="h-3 w-3" />
        </button>
      </div>
      <Separator className="-mx-5" />
      <div className="flex flex-col py-5 gap-2">
        <div className="text-gray-900 text-sm font-medium">
          {props.areaLabel}
        </div>
        <Textarea value={value} rows={6} noResize={true} onChange={setValue} />
      </div>
      <Separator className="-mx-5" />
      <div className="flex pt-5 gap-4">
        <Button color="primary" disabled={!value} onClick={handleApprove}>
          {props.approveButtonText || 'Подтвердить'}
        </Button>
        <Button color="gray" onClick={props.onClose}>
          Отмена
        </Button>
      </div>
    </div>
  );
};
